module.exports = __webpack_public_path__ + "img/04_uk.0898b0b3.svg";